import { useSelector } from 'react-redux'
import {
  CHECKOUT_ORDER_ERROR_TYPE_ALREADY_SUBSCRIBED,
  CHECKOUT_ORDER_ERROR_TYPE_PAYMENT,
  CHECKOUT_ORDER_ERROR_TYPE_POSTAL_CODE,
} from '../checkout/index'
import { selectOrderError } from '../checkout/selectors'
import { selectGiftOrderError, selectGiftOrderErrorCode } from './selectors'

const GENERIC_ERROR_KEY = 'errorGeneric'

// eslint-disable-next-line import/prefer-default-export
export function usePaymentSetupErrorKey () {
  const checkoutOrderError = useSelector(selectOrderError)
  const giftOrderError = useSelector(selectGiftOrderError)
  const giftOrderErrorCode = useSelector(selectGiftOrderErrorCode)
  const isErrorState = checkoutOrderError || giftOrderError

  if (!isErrorState) {
    return null
  }

  let messageKey = GENERIC_ERROR_KEY
  if (
    checkoutOrderError === CHECKOUT_ORDER_ERROR_TYPE_PAYMENT
  ) {
    messageKey = 'errorPayment'
  } else if (
    checkoutOrderError === CHECKOUT_ORDER_ERROR_TYPE_ALREADY_SUBSCRIBED
  ) {
    messageKey = 'errorAlreadySubscribed'
  } else if (checkoutOrderError === CHECKOUT_ORDER_ERROR_TYPE_POSTAL_CODE) {
    messageKey = 'errorPostalCode'
  } else if (giftOrderError) {
    messageKey = giftOrderErrorCode || 'GENERIC_ERROR'
  }

  return messageKey
}
